import Vue, { VueConstructor } from 'vue';
import { ModuleTree } from 'vuex/types';
import { log } from '~/util/log';
import { RootState } from '~/types/store.d';
import store from '~/store/store';
import { ModuleComponent } from '~/types/component';

export default function createComponent(
  componenName: string,
  component: VueConstructor<Vue>,
  storeModules?: ModuleTree<RootState>,
): ModuleComponent {
  const newComponent: ModuleComponent = {
    name: componenName,
    extends: component,
    beforeCreate() {
      if (storeModules) {
        Object.keys(storeModules).forEach(item => {
          store.registerModule(item, storeModules[item]);
        });
      }

      log(`${componenName} created`);
    },
    beforeDestroy() {
      if (storeModules) {
        Object.keys(storeModules).forEach(item => {
          store.unregisterModule(item);
        });
      }
      log(`${componenName} destroy`);
    },
  };

  return newComponent;
}
